import React, { useState, useEffect } from "react";
import { Button, FloatingLabel, Form, Modal } from "react-bootstrap";
import axios from "../../../constents/axios";

const ORACLE_STORAGE_URL = process.env.REACT_APP_ORACLE_STORAGE_URL;
const AUTH_TOKEN = process.env.REACT_APP_AUTH_TOKEN;

const EditEvent = ({ handleClose, eventId, getEvents }) => {
  console.log("eventId:", eventId);

  const [color, setColor] = useState("#563d7c");
  const [formData, setFormData] = useState({
    eventTitle: "",
    joinText: "",
    linkName: "",
    description: "",
    buttonText: "",
    buttonColor: color,
    desktopImage: null,
    phoneImage: null,
    eventDate: "",
    eventTime: "",
    eventFee: "",
  });

  // Fetch event data from API
  useEffect(() => {
    const fetchEventDetails = async () => {
      try {
        const response = await axios.get(`/events/getCurrentEvent/${eventId}`);
        const data = response.data;
        // Extract date and time separately from event_date
        let eventDate = "";
        let eventTime = "";
        if (data.event_date) {
          const eventDateTime = new Date(data.event_date);
          eventDate = eventDateTime.toISOString().split("T")[0]; // YYYY-MM-DD format
          eventTime = eventDateTime.toTimeString().slice(0, 5); // HH:MM format
        }
        
        console.log("data:", data);
        
        setFormData({
          eventTitle: data.title || "",
          joinText: data.join_text || "",
          linkName: data.url_action || "",
          description: data.description || "",
          buttonText: data.button_text || "",
          buttonColor: data.buttonColor || "#563d7c",
          desktopImage: data.image_url_desktop || null,
          phoneImage: data.image_url_mobile || null,
          eventDate: eventDate, // Extracted Date (YYYY-MM-DD)
          eventTime: eventTime, // Extracted Time (HH:MM:SS)
          eventFee: data.event_fee || "",
        });
        setColor(data.button_color || "#563d7c");
      } catch (error) {
        console.error("Error fetching event details:", error);
      }
    };

    if (eventId) {
      fetchEventDetails();
    }
  }, [eventId]);

  useEffect(() => {
    setFormData((prev) => ({ ...prev, buttonColor: color }));
  }, [color]);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });
  };

  const handleFileChange = (e) => {
    const { id, files } = e.target;
    setFormData({ ...formData, [id]: files[0] });
  };

  const uploadToOracle = async (file) => {
    if (!file) return null;
    const fileName = `${Date.now()}-${file.name}`;
    const fileUrl = `${ORACLE_STORAGE_URL}Events/${fileName}`;
    try {
      const response = await axios.put(fileUrl, file, {
        headers: {
          "Content-Type": file.type,
          Authorization: AUTH_TOKEN,
        },
      });
      return response.status === 200 ? fileUrl : null;
    } catch (error) {
      console.error("Oracle upload error:", error);
      return null;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const desktopImageUrl =
      formData.desktopImage instanceof File
        ? await uploadToOracle(formData.desktopImage)
        : formData.desktopImage;
    const phoneImageUrl =
      formData.phoneImage instanceof File
        ? await uploadToOracle(formData.phoneImage)
        : formData.phoneImage;

    if (!desktopImageUrl || !phoneImageUrl) {
      alert("Failed to upload images. Please try again.");
      return;
    }

    console.log("Form Data Submitted:", formData);
    
    const eventDateTime = new Date(`${formData.eventDate} ${formData.eventTime}`).toISOString();

    const updatedEvent = {
      ...formData,
      event_date: eventDateTime,
      desktopImage: desktopImageUrl,
      phoneImage: phoneImageUrl,
    };

    try {
      await axios.put(`/events/updateEvent/${eventId}`, updatedEvent, {
        headers: { "Content-Type": "application/json" },
      });
      alert("Event Updated Successfully!");
      handleClose();
      getEvents();
    } catch (error) {
      console.error("Error updating event:", error);
      alert("Failed to update event");
    }
  };

  return (
    <Modal show onHide={handleClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Edit Event</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <FloatingLabel controlId="eventTitle" label="Title" className="mb-2">
            <Form.Control
              type="text"
              value={formData.eventTitle}
              onChange={handleChange}
              required
            />
          </FloatingLabel>
          <FloatingLabel
            controlId="joinText"
            label="Join Text"
            className="mb-2"
          >
            <Form.Control
              type="text"
              value={formData.joinText}
              onChange={handleChange}
              required
            />
          </FloatingLabel>
          <FloatingLabel
            controlId="linkName"
            label="Link Name"
            className="mb-2"
          >
            <Form.Control
              type="text"
              value={formData.linkName}
              onChange={handleChange}
              required
            />
          </FloatingLabel>
          <FloatingLabel
            controlId="description"
            label="Description"
            className="mb-2"
          >
            <Form.Control
              as="textarea"
              style={{ height: "100px" }}
              value={formData.description}
              onChange={handleChange}
              required
            />
          </FloatingLabel>
          <FloatingLabel
            controlId="buttonText"
            label="Button Text"
            className="mb-2"
          >
            <Form.Control
              type="text"
              value={formData.buttonText}
              onChange={handleChange}
              required
            />
          </FloatingLabel>
          <div className="row">
            <div className="col-md-6">
              <Form.Group controlId="desktopImage" className="mb-3">
                <Form.Label>Desktop Image</Form.Label>
                {formData.desktopImage && (
                  <img
                    src={
                      formData.desktopImage instanceof File
                        ? URL.createObjectURL(formData.desktopImage)
                        : formData.desktopImage
                    }
                    alt="Desktop Preview"
                    className="img-fluid mb-2"
                    style={{ maxHeight: "150px", display: "block" }}
                  />
                )}
                <Form.Control
                  type="file"
                  accept="image/*"
                  onChange={handleFileChange}
                />
              </Form.Group>
            </div>
            <div className="col-md-6">
              <Form.Group controlId="phoneImage" className="mb-3">
                <Form.Label>Phone Image</Form.Label>
                {formData.phoneImage && (
                  <img
                    src={
                      formData.phoneImage instanceof File
                        ? URL.createObjectURL(formData.phoneImage)
                        : formData.phoneImage
                    }
                    alt="Phone Preview"
                    className="img-fluid mb-2"
                    style={{ maxHeight: "150px", display: "block" }}
                  />
                )}
                <Form.Control
                  type="file"
                  accept="image/*"
                  onChange={handleFileChange}
                />
              </Form.Group>
            </div>
          </div>
          <Form.Label>Button Color</Form.Label>
          <div className="row">
            <div className="col-md-2">
              <Form.Control
                type="color"
                value={color}
                onChange={(e) => setColor(e.target.value)}
                required
              />
            </div>
            <div className="col-md-10">
              <FloatingLabel
                controlId="eventFee"
                label="Event Fee"
                className="mb-2"
              >
                <Form.Control
                  type="number"
                  value={formData.eventFee}
                  onChange={handleChange}
                  required
                />
              </FloatingLabel>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <FloatingLabel
                controlId="eventDate"
                label="Event Date"
                className="mb-2 mt-3"
              >
                <Form.Control
                  type="date"
                  value={formData.eventDate}
                  onChange={handleChange}
                  required
                />
              </FloatingLabel>
            </div>
            <div className="col-md-6">
              <FloatingLabel
                controlId="eventTime"
                label="Event Time"
                className="mb-2 mt-3"
              >
                <Form.Control
                  type="time"
                  value={formData.eventTime}
                  onChange={handleChange}
                  required
                />
              </FloatingLabel>
            </div>
          </div>
          <div className="text-center mt-4">
            <Button variant="primary" type="submit">
              Update Event
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default EditEvent;
